export default {
  title: {
    create: 'สร้างข้อมูลแพทย์',
    edit: 'แก้ไขข้อมูลแพทย์',
    productTotal: 'ยอดรวมสินค้า',
    formulaTotal: 'ยอดรวมสูตรยา',
    serviceTotal: 'ยอดรวมบริการ'
  },
  label: {
    medicalDoctor: 'แพทย์ผู้รักษา',
    recommendedRestPeriod: 'แพทย์แนะนำให้พักรักษาตัวเป็นเวลา',
    doctorSection2: 'ส่วนที่ 2 ของแพทย์',
    compensation: 'ค่าตอบแทน',
    stepByStepFee: 'ค่าตรวจแบบขั้นบันได',
    fare: 'ค่านั่ง',
    handlingFee: 'ค่ามือ',
    doctorDF: 'ค่ามือ DF แพทย์',
    assDF: 'ค่ามือ DF ผู้ช่วยแพทย์',
    treadDF: 'ค่ามือ DF แพทย์ผู้รักษา',
    typeOffare: 'ประเภทค่านั่ง',
    since: 'ตั้งแต่คนที่',
    stepUp: 'เพิ่มขั้น',
    specialistDoctor: 'หมอเฉพาะทาง',
    overtimeFee: 'ค่านั่งเกินเวลา (ต่อชั่วโมง)',
    inspectionDay: 'วันลงตรวจ',
    infoCommission1: 'ค่าคอมมิชชั่นสูตรยา จะถูกแบ่งจากกำไรของสูตรยา ที่กำหนดไว้ในการตั้งค่าระบบ',
    infoCommission2: 'ค่าคอมมิชชั่นสินค้า จะถูกแบ่งจาก ค่าคอมมิชชั่น ที่กำหนดไว้ในแต่ละสินค้า',
    professionalInformation: 'ข้อมูลวิชาชีพ',
    licenseNumber: 'เลขใบประกอบวิชาชีพ',
    licenseNumberEng: 'เลขใบประกอบวิชาชีพ (อังกฤษ)',
    professionalInfo: 'ข้อมูลวิชาชีพ',
    treatmentType: 'ประเภทการรักษา',
    educationalRecord: 'ประวัติการศึกษา',
    contractDocument: 'เอกสารสัญญาจ้าง',
    formulaCommission: 'ค่าคอมมิชชั่นสูตรยา',
    patientNeed: 'คนไข้ต้องการใบรับรองแพทย์',
    applicantPart1: 'ส่วนที่ 1 ของผู้ขอรับใบรับรองสุขภาพ',
    maleDoctorAndfemaleDoctor: 'นายแพทย์/ แพทย์หญิง',
    type: 'ประเภทแพทย์'
  },
  placeholder: {
    typeOffare: 'เลือกประเภทค่านั่ง',
    fare: 'กรอกค่านั่ง',
    licenseNumber: 'กรอกเลขใบประกอบวิชาชีพ',
    licenseNumberEng: 'กรอกเลขใบประกอบวิชาชีพ (อังกฤษ)',
    treatmentType: 'เลือกประเภทการรักษา',
    educationalRecord: 'กรอกประวัติการศึกษา',
    contractDocument: 'แนบเอกสารสัญญาจ้าง',
    formulaCommission: 'กรอกค่าคอมมิชชั่นสูตรยา',
    enterTypeInfo: 'กรอกข้อมูลประเภทแพทย์'

  },
  header: {

  },
  tooltip: {
    printOPD: 'พิมพ์ใบ OPD',
    printOrder: 'พิมพ์ใบสั่งยา',
    Order: 'ใบสั่งยา'
  },
  button: {

  },
  alert: {
    createDoctorSuc: 'สร้างข้อมูลแพทย์สำเร็จ !',
    editDoctorSuc: 'แก้ไขข้อมูลแพทย์สำเร็จ !',
    DeleteDoctorSuc: 'ลบแพทย์สำเร็จ !',
    DF: 'โปรดเลือกรูปแบบการคิดค่ามือ DF'
  },
  status: {
    hourly: 'รายชั่วโมง',
    daily: 'รายวัน',
    monthly: 'รายเดือน',
    yearly: 'รายปี',
    custom: 'กำหนดเอง'
  },
  modal: {
    confirmDeleteDoctorTi: 'ยืนยันการลบแพทย์',
    confirmDeleteDoctorSub1: 'คุณกำลังลบแพทย์',
    confirmDeleteDoctorSub2: 'ต้องการดำเนินการต่อหรือไม่',
    create: {
      success: 'สร้างข้อมูลประเภทแพทย์สำเร็จ !'
    },
    delete: {
      title: 'ยืนยันการลบแพทย์',
      subTitle: 'คุณกำลังลบแพทย์',
      subTitle2: 'ต้องการดำเนินการต่อหรือไม่ ?',
      success: 'ลบแพทย์สำเร็จ'
    }
  },
  dayName: {
    Sunday: 'อาทิตย์',
    Monday: 'จันทร์',
    Tuesday: 'อังคาร',
    Wednesday: 'พุธ',
    Thursday: 'พฤหัสบดี',
    Friday: 'ศุกร์',
    Saturday: 'เสาร์'
  },
  dayNameShort: {
    Sunday: 'อา',
    Monday: 'จ',
    Tuesday: 'อ',
    Wednesday: 'พ',
    Thursday: 'พฤ',
    Friday: 'ศ',
    Saturday: 'ส'
  }
}
